import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  site_name: "Conexus Foundation",
  site_tagline: "Earth Monitoring",
  logo_url: "",
  favicon_url: "",
  primary_color: "#10b981",
};

const BrandingContext = createContext({ branding: DEFAULTS, refresh: () => {} });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const r = await axios.get(`${API}/branding`);
      setBranding({ ...DEFAULTS, ...r.data });
    } catch { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // Sync favicon + tab title with current branding
  useEffect(() => {
    if (branding.favicon_url) {
      const url = branding.favicon_url.startsWith("http")
        ? branding.favicon_url
        : `${process.env.REACT_APP_BACKEND_URL || ""}/${branding.favicon_url.replace(/^\/+/, "")}`;
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
      }
      link.href = url;
    }
    if (branding.site_name) {
      const suffix = branding.site_tagline ? ` - ${branding.site_tagline}` : "";
      document.title = `${branding.site_name}${suffix}`;
    }
  }, [branding.favicon_url, branding.site_name, branding.site_tagline]);

  return (
    <BrandingContext.Provider value={{ branding, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
}

export function useBranding() {
  return useContext(BrandingContext);
}
